import React, { useEffect } from 'react';
import styled from 'styled-components';
import shallow from 'zustand/shallow';

import ChartControls from '~/components/ChartControls';
import ColumnSelect from '~/components/ChartControls/ColumnSelect';
import ViewSelect from '~/components/ChartControls/ViewSelect';
import ModeSelect from '~/components/ChartControls/ModeSelect';
import Chart from '~/components/Chart';
import Tooltip from '~/components/Tooltip';

import useStore from '~/store';

const Wrapper = styled.div`
  background: white;
  border-radius: 3px;
  flex-direction: column;
`;

const TooltipWrapper = styled.div`
  position: relative;
  min-height: 200px;
`;

const selector = (s) => ({
  loadData: s.loadData,
  leftSheet: s.leftSheet,
  rightSheet: s.rightSheet,
  leftData: s.leftData,
  rightData: s.rightData,
  currentView: s.currentView,
});

const Visualisation = () => {
  const { loadData, leftSheet, rightSheet, leftData, rightData, currentView } = useStore(selector, shallow);

  useEffect(() => {
    loadData(leftSheet, currentView, 'left');
  }, [leftSheet, currentView]);

  useEffect(() => {
    loadData(rightSheet, currentView, 'right');
  }, [rightSheet, currentView]);

  const isLoading = !leftData || !rightData;

  return (
    <Wrapper>
      <ChartControls />
      <TooltipWrapper>
        <Tooltip />
        {!isLoading && <Chart />}
      </TooltipWrapper>
      <ViewSelect />
      <ModeSelect />
      <ColumnSelect />
    </Wrapper>
  );
};

export default Visualisation;
